export default "__VITE_ASSET__ca36bf73__"